import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { ILayoutProps } from '@common/interface';
import Header from './Header';
import Footer from './Footer';
import './styles.css';
import SuggestionBox from '../SuggestionBox';

const Layout: React.FC<ILayoutProps> = props => {
	const { children, pageInfo, bgClass } = props;
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div className={`layout ${bgClass}`}>
			<Header pageInfo={pageInfo} />
			<main className="layout-content">{children}</main>
			<SuggestionBox />
			<Footer />
		</div>
	);
};

export default Layout;
